import React, { useState, useEffect } from "react";
import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/CMS";
import commonConstant from "../../constants/Common";
import configuration from "../../config";
import { toast } from "react-toastify";
import UND from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add CMS
function Add({ history }) {
  const [fieldArr, setFieldArr] = useState([]);
  const [fields, setFields] = useState({});
  const [errors, setErrors] = useState({});
  const [languages, setLanguages] = useState([]);
  const [description, setDescription] = useState({});
  const [isLoader, setIsLoader] = useState(false);

  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];

  const columnArr = [
    { id: 0, title: "Title", name: "title", type: "TextInput" },
    { id: 1, title: "Code", name: "template_code", type: "TextInput" },
    {
      id: 2,
      title: "User Type",
      name: "user_type",
      type: "Dropdown",
      options: commonConstant.user_type,
    },
    {
      id: 3,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ];
  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "STATIC_PAGES");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });
    getlanguages();
  }, []);

  function getlanguages() {
    configuration
      .getAPI({ url: "language/list", params: { status: "active" } })
      .then((data) => {
        if (data.status === 200) {
          setLanguages(data.payload);
          let descriptionArr = [];
          UND.each(data.payload, (lang, ind) => {
            descriptionArr.push({
              id: ind,
              title: "Description [" + lang.title + "]",
              name: "description_" + lang.code,
              type: "Editor",
              is_full_screen: true,
            });
          });
          const fullCoulnmArr = columnArr.concat(descriptionArr);
          setFieldArr(fullCoulnmArr);
        }
      })
      .catch((error) => {
        return toast.error(error.message);
      });
  }

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.title) {
      error["title"] = "Please enter CMS title";
      flag = false;
    }
    if (!fields.template_code) {
      error["template_code"] = "Please enter template code ";
      flag = false;
    }
    if (!fields.user_type) {
      error["user_type"] = "Please select user type";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }

    // UND.each(languages, (lang, ind) => {
    //   if (!fields['description_' + lang.code]) {
    //     error['description_' + lang.code] = "Please enter description in " + lang.title
    //     flag = false
    //   }
    // })
    setErrors({ ...error });
    return flag;
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      const fullObj = {
        ...description,
        ...fields,
      };
      configuration
        .postAPI({ url: "cms/create", params: fullObj })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/cms");
            toast.success("Record added successfully");
          } else if (data.status === 404) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  function handleChange(field, e) {
    if (field.search("description") >= 0) {
      setDescription({ ...description, [field]: e.target.getContent() });
    } else {
      setFields({ ...fields, [field]: e.target.value });
    }
  }
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addCMS} />
      <AddEditSection
        title="Add CMS"
        path="/cms"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
